/**
 * KAN-834: вход менеджера в приложение по одноразовой ссылке
 * /m/login/:uid/:token. Ссылка неверная, использована или истекла: текст от backend.
 * KAN-845: после входа сразу экран "Начало работы" (/m/start): главный экран,
 * телефон, уведомления, Telegram.
 * KAN-867: открытие ссылки её не обменивает (превью и сканеры ссылок гасили
 * одноразовую ссылку); обмен только по кнопке "Войти".
 */
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { MobileScreen } from '@/components/mobile/MobileScreen';
import { Button } from '@/components/ui/button';
import { useAppLinkLogin } from '@/hooks/useAppLinkLogin';
import { MOBILE_START_PATH } from '@/lib/mobileApp';
import { ONBOARDING_NAV_STATE } from '@/lib/managerOnboarding';

export function MobileLoginPage(): JSX.Element {
  const { uid = '', token = '' } = useParams<{ uid: string; token: string }>();
  const navigate = useNavigate();
  const { state, error, submit } = useAppLinkLogin(uid, token);

  useEffect(() => {
    if (state === 'success') navigate(MOBILE_START_PATH, { replace: true, state: ONBOARDING_NAV_STATE });
  }, [state, navigate]);

  const pending = state === 'pending' || state === 'success';

  return (
    <MobileScreen>
      {state !== 'error' && (
        <div className="flex flex-col items-center gap-4 text-center" data-testid="app-login-start">
          <p className="text-lg font-semibold text-gray-900">Вход в приложение менеджера</p>
          <p className="text-gray-600">Нажмите, чтобы войти. Ссылка работает один раз.</p>
          <Button
            type="button"
            size="lg"
            className="w-full"
            data-testid="app-login-button"
            disabled={pending}
            onClick={submit}
          >
            {pending && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />}
            {pending ? 'Входим...' : 'Войти'}
          </Button>
        </div>
      )}
      {state === 'error' && (
        <div className="space-y-2" data-testid="app-login-error">
          <p className="text-lg font-semibold text-gray-900">Не удалось войти</p>
          <p className="text-gray-700">{error}</p>
        </div>
      )}
    </MobileScreen>
  );
}
